module.exports = __webpack_public_path__ + "img/75578.7b143d68.svg";